
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.807 14.02"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_38037","data-name":"Group 38037","transform":"translate(.041 .041)"}},[_c('g',{attrs:{"id":"Group_38038","data-name":"Group 38038"}},[_c('path',{attrs:{"id":"Path_28009","data-name":"Path 28009","d":"M.459 3.597v6.744a3.138 3.138 0 003.138 3.138h12.531a3.138 3.138 0 003.138-3.138V3.597A3.138 3.138 0 0016.128.459H3.597A3.138 3.138 0 00.459 3.597zm.136-1.71l8.793 5.122.471.25.474-.249 8.794-5.122","fill":"none","stroke":"#b3b3b3","stroke-linejoin":"round","stroke-width":"1"}})])])])
          )
        }
      }
    